import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import api from '@/api';
import { storage } from '@/utils/storage';
import { ACCESS_TOKEN, API_AUTH_LOGIN, REFRESH_TOKEN } from '@/constants/constant';
import { pauth } from '@/proto/proto';

export const postLogin = createAsyncThunk(API_AUTH_LOGIN, async ({ email, password }: pauth.IPbLoginRequest) => {
  const response = await api.post(API_AUTH_LOGIN, 'pauth.PbLoginRequest', { email, password });
  return response.data;
});

export const getMe = createAsyncThunk('/account/user/me', async () => {
  const response = await api.get('/user/me');
  return response.data;
});

const accountSlice = createSlice({
  name: 'account',
  initialState: {
    loading: false,
    accessToken: storage.get(ACCESS_TOKEN, true),
    refreshToken: storage.get(REFRESH_TOKEN, true),
    user: null as any | null,
    prevPage: '',
  },
  reducers: {
    setToken: (state, { payload }: PayloadAction<any>) => {
      state.accessToken = payload.accessToken;
      state.refreshToken = payload.refreshToken;

      storage.set(ACCESS_TOKEN, payload.accessToken, true);
      storage.set(REFRESH_TOKEN, payload.refreshToken, true);
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setPrevPage(state, { payload }: PayloadAction<string>) {
      state.prevPage = payload;
    },
    logout: (state) => {
      state.accessToken = '';
      state.refreshToken = '';
      state.user = null;
      state.prevPage = '';

      storage.remove(ACCESS_TOKEN, true);
      storage.remove(REFRESH_TOKEN, true);
    },
  },
  extraReducers: {
    [postLogin.pending.type]: (state) => {
      state.loading = true;
    },
    [postLogin.fulfilled.type]: (state, { payload }: PayloadAction<pauth.IPbLoginResponse>) => {
      state.loading = false;
      state.accessToken = payload.accessToken;
      state.refreshToken = payload.refreshToken;
      storage.set(ACCESS_TOKEN, payload.accessToken, true);
      storage.set(REFRESH_TOKEN, payload.refreshToken, true);
    },
    [postLogin.rejected.type]: (state) => {
      state.loading = false;
      state.user = null;
      state.accessToken = '';
      state.refreshToken = '';
    },
    [getMe.pending.type]: (state) => {
      state.loading = true;
    },
    [getMe.fulfilled.type]: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.user = payload.toJSON();
    },
    [getMe.rejected.type]: (state) => {
      state.loading = false;
      state.user = null;
    },
  },
});

export const { setToken, setUser, setPrevPage, logout } = accountSlice.actions;
export default accountSlice.reducer;
